module.exports = __webpack_public_path__ + "static/media/LI7.bfdaad6d.jpg";